const MONTH_LENGTH = 30.436875;
const PRODUCTION_CUTOFF = 0.01;

export async function calculateTypeCurve(production, forecast, fullCycle) {
  try {

    let newProduction = {
      byFluid: {
        'oil': [],
        'gas': [],
        'condensate': [],
        'water': [],
      },
      fluids: []
    };

    if (fullCycle) {
      forecast.forEach((well,i) => {
        if (well && well?.byFluid && Object.keys(well?.byFluid)?.length > 0) {
          Object.keys(well?.byFluid)?.forEach(fluid => {
            if (well?.byFluid?.[fluid]?.length > 0) {
              if (newProduction.fluids.indexOf(fluid) === -1) newProduction.fluids.push(fluid);
              
              const lastMonth = production[i]?.byFluid?.[fluid]?.slice(-1)?.[0]?.monthsOnline; // get the last month of historic production for the well

              well?.byFluid[fluid]?.forEach((d, m) => {
                let volume = 0;
                if (d?.monthsOnline <= lastMonth) {  // use the historic production portion of the well
                  volume = production[i]?.byFluid?.[fluid]?.find(p => p.monthsOnline === d.monthsOnline)?.volume || 0;
                } else { // use the forecast portion of the well
                  volume = d?.volume?.p50 || 0;
                };
                if (!newProduction.byFluid[fluid][m]) {
                  newProduction.byFluid[fluid].push({
                    volume: [volume],
                    cumVolume: []
                  });
                } else {
                  newProduction.byFluid[fluid][m].volume.push(volume);
                };
              });
            };
          });
        };
      });
    } else {
      production.forEach(well => {
        if (well && well.fluids?.length > 0) {
          well?.fluids?.forEach(fluid => {
            if (newProduction.fluids.indexOf(fluid) === -1) newProduction.fluids.push(fluid);
            well?.byFluid[fluid]?.forEach((d, m) => {
              if (!newProduction.byFluid?.[fluid]?.[m]) {
                newProduction.byFluid[fluid].push({
                  volume: [d?.volume || 0],
                  cumVolume: []
                });
              } else {
                newProduction.byFluid[fluid][m].volume.push(d?.volume || 0);
              };
            });
          });
        };
      });
    };

    let startDate = new Date();
    startDate = new Date(Date.UTC(startDate?.getFullYear(), startDate.getMonth(), 2)); // set the start month as the 2nd day of the current month

    newProduction.fluids.forEach(fluid => {
      newProduction.byFluid[fluid].forEach((prod,m) => {
        const vol = prod.volume.length >= 2 ? getMean(prod.volume) : prod.volume?.[0];
        const cumVol = m === 0 ? vol : (newProduction.byFluid[fluid][m - 1]?.cumVolume + vol);
        newProduction.byFluid[fluid][m].volume = vol;
        newProduction.byFluid[fluid][m].cumVolume = cumVol;
        newProduction.byFluid[fluid][m].monthsOnline = m + 1;
        newProduction.byFluid[fluid][m].date = new Date(new Date(startDate).setMonth(startDate?.getMonth() + m))?.toISOString()?.split('T')?.[0];
      });
    });

    function getMean(volumes) {
      try {
        if (!volumes || volumes.length === 0) return 0;

        let count = 0;
        let sum = 0;
        volumes.forEach(volume => {
          if (volume / MONTH_LENGTH > PRODUCTION_CUTOFF) {
            sum += volume;
            count++;
          };
        });
        return (sum / count) || 0;
        
      } catch (error) {
        console.log(error);
        return 0;
      };
    };

    Object.keys(newProduction.byFluid).forEach(fluid => {
      if (newProduction.fluids.indexOf(fluid) === -1) delete newProduction.byFluid[fluid];
    });

    return newProduction;
  } catch (error) {
    console.log('Could not calculate type curve');
    console.log(error);
    return;
  };
};